import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BasketNotificationProps {
  open: boolean;
  onClose: () => void;
}

export const BasketNotification = ({ onClose, open }: BasketNotificationProps) => {
  const { t } = useTranslation(['RoutesListComponent', 'Common']);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      ClickAwayListenerProps={{ onClickAway: () => null }}
    >
      <Alert severity="success">
        {t('RoutesListComponent:ProductNotification')}
        <Link href={t('Common:BasketLink')} underline="hover">
          {t('RoutesListComponent:ProducttNotificationOrderLink')}
        </Link>
      </Alert>
    </Snackbar>
  );
};
